// extracted by mini-css-extract-plugin
export default {"link":"uUxqWY","root":"Vq4wYb","label":"wJVzSK"};